import {
  HOME_PAGE_LOADED,
  HOME_PAGE_UNLOADED,
  ASYNC_START
} from '../constants/actionTypes';
import { REACT_APP_BASE_COIN_SYMBOL } from '../constants/config'

export default (state = {}, action) => {
  switch (action.type) {
    case HOME_PAGE_LOADED:
      return {
        ...state,
        transactions: action.error ? [] : action.payload[0].transactions,
        accounts: action.error ? [] : action.payload[1].accounts,
        stats: action.error ? null : action.payload[2].stats
      };
    case HOME_PAGE_UNLOADED:
      return {};
    case ASYNC_START:
      return {
        ...state,
      }
    default:
      return state;
  }
};
